import { FC, PropsWithChildren } from 'react';
import { Provider } from 'react-redux';

import { ConnectedRouter } from 'connected-react-router';
import history from 'utils/history';

import { BreakpointProvider } from '@hh.ru/magritte-ui';

import 'bloko/common/styles/_defaults.less';

import { Clickme } from 'components/Clickme';

import store from 'store';

import 'styles/fonts.less';
import 'styles/globals.less';
import 'styles/uxfeedback.less';

const App: FC<PropsWithChildren> = () => (
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <BreakpointProvider>
                <Clickme />
            </BreakpointProvider>
        </ConnectedRouter>
    </Provider>
);

export default App;
